module.exports = __webpack_public_path__ + "img/gps-icon.1db62f00.svg";